import React, { useState } from 'react'
import { RadioButton } from '@paypalcorp/pp-react'
import { UITabs } from '../components/layout'
import TestScenarios from './TestScenarios'

const countryOptions = [
  { label: 'United States', value: 'us' },
  { label: 'Great Britain', value: 'gb' },
  { label: 'France', value: 'fr' },
  { label: 'Italy', value: 'it' },
  { label: 'Spain', value: 'sp' },
]

const ThreeDSTestScenarios = () => {
  const [selectedCountry, setSelectedCountry] = useState(
    countryOptions[0].value,
  )

  const handleChange = (e: any) => {
    const optedCountry = e?.target?.value
    setSelectedCountry(optedCountry)
  }

  return (
    <div>
      <div label="3DS 2.2">
        <RadioButton
          id="rb-country"
          label="Country"
          name="country"
          value={selectedCountry}
          onChange={(e) => handleChange(e)}
          options={countryOptions}
          style={{ marginBottom: '1.5rem' }}
        />
        <TestScenarios country={selectedCountry} type="3ds2" />
      </div>
    </div>
  )
}

export default ThreeDSTestScenarios
